import React, { useState,useEffect, useCallback, useRef } from 'react';
import Logo from "../images/logo.svg";
import Sidebar from '../component/Sidebar';
import { SelectPicker, DatePicker, Dropdown, Placeholder, Whisper, Button, Popover, Message, useToaster, Tooltip, Input, Modal} from "rsuite";
import 'rsuite/SelectPicker/styles/index.css';

import 'aos/dist/aos.css';
import AOS from 'aos';
import debounce from 'lodash.debounce';
import IconDelete from "../images/deleteBG.svg";
import IconInfo from "../images/IconErrorInfo.svg";
import IconError from "../images/IconError.svg";
import IconCheckError from "../images/IconCheckError.svg";
import { useParams ,Link, useNavigate } from "react-router-dom";
import icon_Asc from "../images/Asc.svg";
import icon_Desc from "../images/Desc.svg";

import icon1_Asc from "../images/Asc.svg";
import icon1_Desc from "../images/Desc.svg";

import icon2_Asc from "../images/Asc.svg";
import icon2_Desc from "../images/Desc.svg";

import icon3_Asc from "../images/Asc.svg";
import icon3_Desc from "../images/Desc.svg";

import iconArrowDrop from "../images/iconArrowDrop.svg";
import Icon_info from "../images/iconInfo.svg";




function ETFHistoryCycle() {

    const [tabName, setTabName] = useState('ETF History Cycle');
    const { company_symbol } = useParams();
    useEffect(() => {
      document.title = tabName;
    }, [tabName]);
    

useEffect(() => {
    AOS.init();
  }, []);

  const abortControllerRef = useRef(null);
  const [isLoading, setLoading] = useState(true); // State to manage loading state
  const apiEndPoint = process.env.REACT_APP_ETF_API_ENDPOINT;
  const apiEndPoint1 = process.env.REACT_APP_API_ENDPOINT;
  const frontEndLink = process.env.REACT_APP_MUSAFFA_LINK;
  const roleName = localStorage.getItem("novaRolename");
  const merlinJuniorAnalyst = process.env.REACT_APP_MERLIN_JUNIOR_ANALYST;
  const [pageRange, setPageRange] = useState("20");
  const [reportData, setReportData] = useState([]);
  const [reportCount, setReportCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [startPage, setStartPage] = useState(1);

  const userid = localStorage.getItem("novauserid");
  const progressStatus = process.env.REACT_APP_TASK_MANAGER_PROGRESS_Status;

  const [errorMessage, setErrorMessage] = useState('');
  const [messageType, setMessageType] = useState(null); // success, error, info

  const [orderBy, setOrderBy] = useState("total_holdings"); // default orderBy
  const [order, setOrder] = useState("DESC"); // default order

  const [isAscending, setIsAscending] = useState(false);
  const [isAscending1, setIsAscending1] = useState(true);
  const [isAscending2, setIsAscending2] = useState(true);
  
  

  const handleIconClick = (columnName) => {
    // Toggle between ascending and descending icons
    
    setOrderBy(columnName);

    switch (columnName) {
      case "total_holdings":
        setIsAscending(!isAscending);
        setOrder(isAscending ? "DESC" : "ASC");
        break;
      case "total_uncovered":
        setIsAscending2(!isAscending2);
        setOrder(isAscending2 ? "DESC" : "ASC");
        break;
        case "total_cover":
          setIsAscending1(!isAscending1);
          setOrder(isAscending1 ? "DESC" : "ASC");
          break;
      default:
        setIsAscending(!isAscending);
        setOrder(isAscending ? "DESC" : "ASC");
        break;
    }
    
  };

    const fetchGlobalReport = async () => {
      setLoading(true);
  
      // Cancel the previous request if any
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

     // Create a new AbortController for the current request
     const controller = new AbortController();
     abortControllerRef.current = controller;

    try {
        // TODO: Replace with actual API endpoint for ETF History Cycle
        const apiUrl = `${apiEndPoint}/etf_cycle_history`;
        const requestData = {
          data: {
            user_id: userid,
            symbol: company_symbol
          }
        };
        console.log(JSON.stringify(requestData));
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestData),
          signal: controller.signal
        });
  
        const jsonData = await response.json();
        console.log('API Response:', jsonData);
        
        // Handle the specific API response structure
        const responseData = jsonData.data;
        const status = responseData.status;
        const message = responseData.message;
        const count = responseData.total_records || 0;
        const data = responseData.history || [];
        
        if (status === "success") {
          setLoading(false);
          setReportCount(count);
          console.log('RES : '+ JSON.stringify(data));
          setReportData(Array.isArray(data) ? data : []);
        } else {
          setLoading(false);
          console.error("Error: ", message);
          setReportData([]);
          setReportCount(0);
        }
      } catch (error) {
        if (error.name === "AbortError") {
          console.log("Request cancelled");
        }
        else{
          console.error("Error fetching data:", error.message);
          setLoading(false);
          setReportData([]);
          setReportCount(0);
        }
        return false;
      }
    };
  
    useEffect(() => {
      fetchGlobalReport();
    }, [currentPage, pageRange, order, orderBy]); // Include order parameters

    
    const [customPaginationValue, setCustomPaginationValue] = useState("");

    // Debounced function to update the page number
    const debouncedSetPage = useCallback(
      debounce((page) => {
        setCurrentPage(page);
      }, 1000), // Delay of 1000ms
      []
    );
  
    const handlePaginationChange = (e) => {
      const value = (e.target.value == 0 ? 1 : e.target.value).toString() ;
      setCustomPaginationValue(value); // Update input value immediately for fast typing
      debouncedSetPage(Number(value)); // Trigger the debounced function
    };
  
    const handlePagelimit = (value) => {
      setCurrentPage(1);
      setCustomPaginationValue(1);
      setPageRange(value); 
    };
  
    
    const renderPagination = () => {
      // Calculate total number of pages
      const totalPages = Math.ceil(reportCount / pageRange);
    
      // Show a default of 3 pages if the total pages are more than 3
      const pageNumbers = [];
      const visiblePageCount = 4; // Number of pages to show by default
    
      let startPage = currentPage - 1;
      let endPage = currentPage + 2;
    
      // Adjust pagination if total pages are less than the default
      if (totalPages <= visiblePageCount) {
        startPage = 1;
        endPage = totalPages;
        
      } else {
        
        // Ensure the pagination does not go out of bounds
        startPage = Math.max(1, startPage);
        endPage = Math.min(totalPages, endPage);
      }
    
      // Create page numbers to display based on current page
      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }
    
      return (
        <nav aria-label="..." id='pagination_row' style={{alignItems:'center', justifyContent:'space-between', background:'#FFF', paddingTop:0, paddingBottom:0}}>
          <div className='totalRecords'>
            Total Records :  {Number(reportCount).toLocaleString()}
          </div>
          <ul className="pagination" style={{border: 0, background: 'none'}}>
  
          <li class="page-item" style={{marginLeft:10}}>
                        <SelectPicker onChange={handlePagelimit} cleanable={false}
                        value={pageRange} 
                        placement="top" placeholder='Pages' data={PagingData} searchable={false} style={{ width: 85, height:35, display:'flex', alignItems:'center', borderRadius: 5, border: '1px solid #A1B9ED'}} />
                      </li>
  
            {/* Previous Page (Double Arrow) */}
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`} style={{marginLeft: 10}}>
              <a href="#" className="page-link" onClick={() => setCurrentPage(1)}>
                <i className="fa fa-angle-double-left"></i>
              </a>
            </li>
    
            {/* Previous Page (Single Arrow) */}
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
              <a href="#" className="page-link" onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}>
                <i className="fa fa-angle-left"></i>
              </a>
            </li>
    
            {/* Page numbers */}
            {pageNumbers.map(page => (
              <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                <a 
                  className="page-link" href="#" 
                  onClick={() => setCurrentPage(page)} // Set the clicked page as the current page
                >
                  {page}
                </a>
              </li>
            ))}
            
            {/* Next Page (Single Arrow) */}
            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
              <a href="#" className="page-link" onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}>
                <i className="fa fa-angle-right"></i>
              </a>
            </li>
    
            {/* Next Page (Double Arrow) */}
            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`} style={{marginRight: 10}}>
              <a href="#" className="page-link" onClick={() => setCurrentPage(totalPages)}>
                <i className="fa fa-angle-double-right"></i>
              </a>
            </li>
            
            {/* Go to Page */}
            <li className="page-item" style={{marginLeft: 10, display: 'flex', alignItems: 'center', gap: 5}}>
              <input
                type="text"
                placeholder="Go#"
                className="form-control"
                value={customPaginationValue}
                onChange={handlePaginationChange}
                onInput={(e) => {
                  // Only allow numbers
                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                }}
              
                style={{
                  padding: '0px 10px', 
                  color: '#878787', 
                  fontSize: 16, 
                  borderRadius: 5, 
                  border: '1px solid #A1B9ED', 
                  width: 60, 
                  height: 35, 
                  textAlign: 'center'
                }}
              />
            </li>
          </ul>
        </nav>
      );
    };
    
    
    
  
  // PAGINATION
  const PagingData = ['10', '20', '50', '100'].map(
    item => ({ label: item, value: item })
  );

  const hideMessage = () => {
    setMessageType(null);
  };

  // Error Message

  const renderMessage = () => {
    if (messageType) {
      setTimeout(hideMessage, 5000);
    };

    switch (messageType) {
      case 'success':
        return (
          <Message type="success" closable style={{ display: 'flex', alignItems: 'center', width: 'auto', position:'absolute', right:0, top:10, zIndex:999}}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
              <div className='icon_error_msg Icon_success'>
                <div className='icon_error_msg_inner Icon_success_inner'>
                  <img src={IconCheckError} alt="Success Icon" />
                  <div className="progress-circle progress_circle_success"></div>
                </div>
              </div>
              <div className='error_msg_text error_msg_success_text'>
                <h5>Success</h5>
                <p>{errorMessage}</p>
              </div>
            </div>
          </Message>
        );
      case 'error':
        return (
          <Message type="error" closable style={{ display: 'flex', alignItems: 'center', width: 'auto', position:'absolute', right:0, top:10,zIndex:999}}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
              <div className='icon_error_msg Icon_error'>
                <div className='icon_error_msg_inner Icon_error_inner'>
                  <img src={IconError} alt="Error Icon" />
                  <div className="progress-circle progress_circle_error"></div>
                </div>
              </div>
              <div className='error_msg_text error_msg_error_text'>
                <h5>Error</h5>
                <p>{errorMessage}</p>
              </div>
            </div>
          </Message>
        );
        case 'info':
        return (
          <Message type="info" closable style={{ display: 'flex', alignItems: 'center', width: 'auto', position:'absolute', right:0, top:10}}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
              <div className='icon_error_msg Icon_info'>
                <div className='icon_error_msg_inner Icon_info_inner'>
                  <img src={IconInfo} alt="Info Icon" />
                  <div className="progress-circle progress_circle_info"></div>
                </div>
              </div>
              <div className='error_msg_text error_msg_info_text'>
                <h5>Info</h5>
                <p>{errorMessage}</p>
              </div>
            </div>
          </Message>
        );
        default:
          return null;
    }
  };
  

const triggerRef = React.useRef();
const openUncovered = () => triggerRef.current.openUncovered();
const closeUncovered = () => triggerRef.current.closeUncovered();

  return (
    <>
    <Sidebar/>
    <div id='header'>
    {renderMessage()}
        <div className='logo'>
            <div className='logo_icon'>
                <img src={Logo} />
            </div>
            <div className='brand_name'>ETF History Cycle - {company_symbol}</div>
        </div>

        {/* Removed all filter components */}
    </div>
    <div className="container-fluid content pb-5">
      <div className='company_table_list' data-aos="fade-up" data-aos-duration="800">

      {isLoading && ( <Placeholder.Grid rows={20} columns={9} active style={{paddingLeft:20, paddingRight:20, paddingTop:12}} /> )}

{/* Table */}
{!isLoading && (
    <>
        <div className='table-responsive clsPagingWrap'>
          <table className='table'>
              <thead>
                <tr>
                  <th style={{textAlign:'center'}}>Symbol</th>
                  <th>Name</th>
                  <th style={{textAlign:'center'}}>Status</th>
                  <th style={{textAlign:'center'}}>CBA Status</th>
                  <th>Cycle Date</th>
                  <th style={{textAlign:'center'}}>Asset Class</th>
                  <th style={{textAlign:'center'}}>CMPT</th>
                  <th style={{textAlign:'center'}}>NCMPT</th>
                  <th style={{textAlign:'center'}}>DBFT</th>
                  <th style={{textAlign:'center'}}>Interest</th>
                  <th style={{textAlign:'center'}}>Debt</th>
                  <th >Total Revenue</th>
                  <th style={{textAlign:'center'}}>CMPT Revenue</th>
                  <th style={{textAlign:'center'}}>NCMPT Revenue</th>
                  <th style={{textAlign:'center'}}>DBFT Revenue</th>
                  <th style={{textAlign:'center'}}>IB Assets</th>
                  <th style={{textAlign:'center'}}>IB Liabilities</th>
                  <th style={{textAlign:'center'}}>ETF AUM</th>
                  <th style={{textAlign:'center'}}>Finnhub AUM</th>
                  <th style={{textAlign:'center'}}>NAV</th>
                  <th style={{textAlign:'center'}}>Rating</th>
                  <th style={{textAlign:'center'}}>Currency</th>
                  <th style={{textAlign:'center'}}>Total Holdings</th>
                </tr>
              </thead>
              <tbody>

                
              {reportData.length > 0 ? (
  reportData.map((item, index) => (
                <tr key={item.id || index}>
                <td style={{textAlign:'center'}}>
                    <div className='company_name_td'>
                    <span className='stock_lable'>{item.symbol}</span>
                    </div>
                </td>
                 <td>
                   <div className="company_name_td">
                               <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>{item.name}</Tooltip>}>
                                 <span className='etf_name text_ellipsis'>{item.name}</span>
                               </Whisper>
                   </div>
                   </td>
                 <td style={{textAlign:'center'}}>
                   <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>{item.msg || item.Status}</Tooltip>}>
                     <span
                       style={{ width: 100 }}
                       className={`tag_td ${
                         item.Status === "" || item.Status === null
                           ? ''
                           : item.Status === "CMPT"
                           ? 'halal_tag'
                           : item.Status === "NCMPT"
                           ? 'not_halal_tag'
                           : item.Status === "DBTF"
                           ? 'doughtful_tag'
                           : item.Status === "UCVD"
                           ? 'uncover_tag'
                           : item.Status === "LEVERAGED"
                           ? 'not_halal_tag'
                           : item.Status === "DTER"
                           ? 'data_error_tag'
                           : ''
                       }`}
                     >
                       {item.Status}
                     </span>
                   </Whisper>
                 </td>
                 <td style={{textAlign:'center'}} className={item.cba_status && item.cba_status.toLowerCase() === 'pass' ? 'cba_pass' : 'cba_Fail'}>{item.cba_status}</td>
                 <td>
                   <div className="company_name_td">
                               <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>{item.cycle_date}</Tooltip>}>
                                 <span className='etf_name text_ellipsis'>{item.cycle_date}</span>
                               </Whisper>
                   </div>
                   </td>
                  <td style={{textAlign:'center'}}>{item.asset_class}</td>
                  <td style={{textAlign:'center'}}>{item.halal_ratio}</td>   
                  <td style={{textAlign:'center'}}>{item.not_halal_ratio}</td>                
                  <td style={{textAlign:'center'}}>{item.doubtful_ratio}</td>
                  <td style={{textAlign:'center'}}>{item.interest_ratio}</td>
                  <td style={{textAlign: 'center'}}>{item.debt_ratio}</td>
                  <td style={{textAlign:'right'}}>{item.total_revenue}</td>
                  <td style={{textAlign:'right'}}>{item.compliant_revenue}</td>
                  <td style={{textAlign:'right'}}>{item.non_compliant_revenue}</td>
                  <td style={{textAlign:'right'}}>{item.doubtful_revenue}</td>
                  <td style={{textAlign:'right'}}>{item.interest_bearing_assets}</td>
                  <td style={{textAlign:'right'}}>{item.interest_bearing_liabilities}</td>
                  <td style={{textAlign:'right'}}>{item.etf_aum}</td>
                  <td style={{textAlign:'right'}}>{item.finnhub_aum}</td>
                  <td style={{textAlign:'center'}}>{item.nav}</td>
                  <td style={{textAlign:'center'}}>{item.rating}</td>
                  <td style={{textAlign:'center'}}>{item.currency}</td>
                  <td style={{textAlign:'center'}}>{item.total_holdings}</td>
                  
                </tr> 
 ))
) : (
  <tr>
    <td colSpan="24" style={{ textAlign: "center", fontSize:20, paddingTop:30, paddingBottom:30 }}>
      No data available
    </td>
  </tr>
)}
            
              </tbody> 
          </table>
      
        </div>
        {reportCount > 1 && renderPagination()}
        </>
)}      
      </div>
    </div>


    </>
  );
}

export default ETFHistoryCycle;
